// src/pages/RolesPage.jsx
import React from 'react';
import RoleList from '../../components/roles/RoleList';

const RolePage = () => {
  return <RoleList />;
};

export default RolePage;